import { gql, TypedDocumentNode } from '@common/hooks';
import {
  SendAppInvitationMutationCgResponse,
  SendAppInvitationMutationVariables,
  SyncWorkerUkgDataMutationCgResponse,
  SyncWorkerUkgDataMutationVariables,
} from '@common/graphql/schema';

export const SYNC_WORKER_UKG_DATA_MUTATION: TypedDocumentNode<
  SyncWorkerUkgDataMutationCgResponse,
  SyncWorkerUkgDataMutationVariables
> = gql`
  mutation SyncWorkerUkgData($workerId: ID!) {
    syncWorkerUkgData(workerId: $workerId) {
      message
      error
    }
  }
`;

export const SEND_APP_INVITATION_MUTATION: TypedDocumentNode<
  SendAppInvitationMutationCgResponse,
  SendAppInvitationMutationVariables
> = gql`
  mutation SendAppInvitation($workerId: ID!) {
    sendAppInvitation(workerId: $workerId) {
      message
    }
  }
`;
